import React, { useEffect, useState } from "react";
import { Spinner } from "components/ui";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { skipAutoshipOrder } from "actions/autoship";
import { useDispatch } from "react-redux";
import { checkAuth } from "actions/auth";
import { Button } from "@mui/material";
import Modal from "components/ui/modal";
import useTranslate from "hooks/use-translate-language";

const AutoshipActions = () => {
  const translate = useTranslate();
  const dispatch = useDispatch();
  const location = useLocation();
  const tokenString = queryString.parse(location.search).token;
  const orderId = queryString.parse(location.search).order;

  const [action, setAction] = useState("");
  const [fullToken, setFullToken] = useState("");
  const [isFetching, setIsFetching] = useState(false);

  useEffect(async () => {
    if (tokenString.length == 6) {
      const { token } = await dispatch(checkAuth(tokenString));
      setFullToken(token);
    } else setFullToken(tokenString);
  }, []);

  return (
    <>
      <div className="thanks-screen">
        {!isFetching && (
          <div className="thanks-container">
            Would you like to skip this order or opt-out of autoship?
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around"
              }}
            >
              <Button
                onClick={() => {
                  setAction('skip');
                  document.getElementById("confModal").click();
                }}
                variant="contained"
                color="primary"
              >
                Skip
              </Button>
              <Button
                onClick={() => {
                  setAction('opt-out');
                  document.getElementById("confModal").click();
                }}
                variant="contained"
                color="primary"
              >
                Opt-out
              </Button>
            </div>
          </div>
        )}
        {isFetching && <Spinner />}
        <Modal
          maxWidth="sm"
          fullWidth
          renderTrigger={({ openModal }) => (
            <div id="confModal" onClick={openModal}></div>
          )}
          renderContent={({ closeModal }) => (
            <div
              className="reschedule-chat-modal-container"
              style={{ padding: "10px" }}
            >
              <h3 style={{ marginBottom: "20px" }}></h3>
              <span style={{ fontSize: "20px", padding: "20px" }}>
                {action == "opt-out" ? translate("optOutConfirmation") : translate("skipConfirmation")}
              </span>

              <div style={{ textAlign: "center", paddingTop: "20px" }}>
                <Button
                  variant="contained"
                  color="error"
                  style={{
                    display: "inline-block",
                    marginRight: "150px"
                  }}
                  onClick={() => closeModal()}
                  disabled={isFetching}
                >
                  No
                </Button>
                {
                  <Button
                    variant="contained"
                    style={{ display: "inline-block" }}
                    onClick={() => {
                      setIsFetching(true);
                      dispatch(skipAutoshipOrder(orderId, action, fullToken));
                    }}
                    disabled={isFetching}
                  >
                    <div style={{ textAlign: "center" }}>
                      {translate("yes")}
                    </div>
                  </Button>
                }
                {isFetching && <Spinner style={{ display: "inline-block" }} />}
              </div>
            </div>
          )}
        />
      </div>
    </>
  );
};

export default AutoshipActions;
